import { render, staticRenderFns } from "./MerchantChannelDayClear.vue?vue&type=template&id=c89ef1cc&"
import script from "./MerchantChannelDayClear.vue?vue&type=script&lang=ts&"
export * from "./MerchantChannelDayClear.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MerchantChannelDayClear.vue"
export default component.exports